import DataSummaryContainer from './data-summary.container';

export default DataSummaryContainer;
